import { useContext } from 'react'

import { SplitViewContext } from './SplitViewContext'

export const useSplitViewContext = () => {
  const context = useContext(SplitViewContext)

  if (!context) {
    throw new Error(
      'useSplitViewContext must be used within SplitViewContextProvider',
    )
  }

  return context
}
